const reactEnv: string =
	process.env.REACT_APP_NODE_ENV !== undefined
		? process.env.REACT_APP_NODE_ENV.toString()
		: 'DEV'

const config = {
	// env
	env: process.env.REACT_APP_NODE_ENV,
	isDevEnv: process.env.REACT_APP_NODE_ENV?.toString().toUpperCase() !== 'PROD',

	// shop
	shop: {
		seasonId: process.env.REACT_APP_SEASON_ID,
	},

	// system
	system: {
		name: process.env.REACT_APP_SYSTEM_NAME,
		subtitle: process.env.REACT_APP_SYSTEM_SUBTITLE,
		baseUrl: process.env[`REACT_APP_${reactEnv}_BASE_URL`],
	},

	// aws
	aws: {
		access_key_id: '',
		secret_access_key: '',
		region: {
			default: 'ap-northeast-2',
			sms: 'us-east-1',
		},
		smtpUsername: 'nexetcorp',
		ses_noreply_email: 'noreply@judahs.io',
	},
}

export default config
